// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.alert-notice-snack{
    z-index: 100;
    border-radius: 20px;
    background-color: white;
}
.MuiSnackbar-root.inline-snack{
    position: relative;
}
.alert-notice-snack-alert__container{
    display: flex;
    align-items: center;
    width: 100%;
    box-shadow: 0 4px 4px rgba(0, 0, 0, 0.03), 0 2px 30px rgba(0, 0, 150, 0.07);
    border-radius: 20px;
    border: 1px solid;
    padding: 15px 15px 15px 15px;
    justify-content: space-between;
    min-width: 200px;
    cursor: pointer;
}
.alert-notice-snack.MuiSnackbar-anchorOriginTopCenter{
    top: calc(24px + var(--safe-area-top));
}
.alert-notice-snack.MuiSnackbar-anchorOriginBottomCenter{
    bottom: 1.5rem;
    padding-left: 1rem;
    padding-right: 1rem;
    background-color: transparent;
}
@media screen and (max-width:599px ) {
    .MuiSnackbar-root.inline-snack{
        left: 0;
        right: 0;
    }
}
.alert-notice-snack-alert__text-container{
    display: flex;
    flex-direction: column;
    padding: 0 1rem;
}
.alert-notice-snack-alert__message-title{
    font-weight: bold;
}
.alert-notice-snack-alert__icon-container{
    display: flex;
}

.alert-notice-snack-alert__icon-container--hidden {
    display: none;
}
.alert-notice-snack-alert__icon-container .icon-svg{
    width: 20px;
}
.alert-notice-snack-alert__icon-container .icon-svg path{
    fill: var(--app-text-color-primary);
}
.alert-notice-snack-alert__error{
    border-color: var( --app-fill-color-primary--danger);
    color: var(--app-text-color-primary);
    background-color: var(--app-fill-color-notice-bg-error)!important;

}
.alert-notice-snack-alert__warning{
    border-color: var(--app-fill-color-primary--warning);
    color: var(--app-text-color-primary);
    background-color: var(--app-fill-color-notice-bg-warning)!important;
}
.alert-notice-snack-alert__success{
    border-color: var(--app-fill-color-success);
    color: var(--app-text-color-primary);
    background-color: var(--app-fill-color-notice-bg-success)!important;
}
.alert-notice-snack-alert__info{
    border-color: var(--app-fill-color-success);
    color: var(--app-text-color-primary);
    background-color: var(--app-fill-color-notice-bg-success)!important;
}
.alert-notice-snack-alert__btn-close.MuiIconButton-root{
    color: var(--app-text-color-primary);
}
.alert-notice-snack-alert__btn-close.MuiIconButton-sizeSmall{
    font-size: 0.85rem;
}

.alert-notice-snack__overlay{
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 230;
    background-color: var(--app-menu-icon__text-color--secondary);
}

.alert-notice-line-clamp {
    display: -webkit-box;
    line-clamp: 4;
    -webkit-line-clamp: 4;
    -webkit-box-orient: vertical;
    overflow: hidden;
}
`, "",{"version":3,"sources":["webpack://./src/core/components/modalsPortalsNotices/AlertNotice/styles/AlertNotice.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,mBAAmB;IACnB,uBAAuB;AAC3B;AACA;IACI,kBAAkB;AACtB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,2EAA2E;IAC3E,mBAAmB;IACnB,iBAAiB;IACjB,4BAA4B;IAC5B,8BAA8B;IAC9B,gBAAgB;IAChB,eAAe;AACnB;AACA;IACI,sCAAsC;AAC1C;AACA;IACI,cAAc;IACd,kBAAkB;IAClB,mBAAmB;IACnB,6BAA6B;AACjC;AACA;IACI;QACI,OAAO;QACP,QAAQ;IACZ;AACJ;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,eAAe;AACnB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;AACA;IACI,WAAW;AACf;AACA;IACI,mCAAmC;AACvC;AACA;IACI,oDAAoD;IACpD,oCAAoC;IACpC,iEAAiE;;AAErE;AACA;IACI,oDAAoD;IACpD,oCAAoC;IACpC,mEAAmE;AACvE;AACA;IACI,2CAA2C;IAC3C,oCAAoC;IACpC,mEAAmE;AACvE;AACA;IACI,2CAA2C;IAC3C,oCAAoC;IACpC,mEAAmE;AACvE;AACA;IACI,oCAAoC;AACxC;AACA;IACI,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,YAAY;IACZ,6DAA6D;AACjE;;AAEA;IACI,oBAAoB;IACpB,aAAa;IACb,qBAAqB;IACrB,4BAA4B;IAC5B,gBAAgB;AACpB","sourcesContent":[".alert-notice-snack{\n    z-index: 100;\n    border-radius: 20px;\n    background-color: white;\n}\n.MuiSnackbar-root.inline-snack{\n    position: relative;\n}\n.alert-notice-snack-alert__container{\n    display: flex;\n    align-items: center;\n    width: 100%;\n    box-shadow: 0 4px 4px rgba(0, 0, 0, 0.03), 0 2px 30px rgba(0, 0, 150, 0.07);\n    border-radius: 20px;\n    border: 1px solid;\n    padding: 15px 15px 15px 15px;\n    justify-content: space-between;\n    min-width: 200px;\n    cursor: pointer;\n}\n.alert-notice-snack.MuiSnackbar-anchorOriginTopCenter{\n    top: calc(24px + var(--safe-area-top));\n}\n.alert-notice-snack.MuiSnackbar-anchorOriginBottomCenter{\n    bottom: 1.5rem;\n    padding-left: 1rem;\n    padding-right: 1rem;\n    background-color: transparent;\n}\n@media screen and (max-width:599px ) {\n    .MuiSnackbar-root.inline-snack{\n        left: 0;\n        right: 0;\n    }\n}\n.alert-notice-snack-alert__text-container{\n    display: flex;\n    flex-direction: column;\n    padding: 0 1rem;\n}\n.alert-notice-snack-alert__message-title{\n    font-weight: bold;\n}\n.alert-notice-snack-alert__icon-container{\n    display: flex;\n}\n\n.alert-notice-snack-alert__icon-container--hidden {\n    display: none;\n}\n.alert-notice-snack-alert__icon-container .icon-svg{\n    width: 20px;\n}\n.alert-notice-snack-alert__icon-container .icon-svg path{\n    fill: var(--app-text-color-primary);\n}\n.alert-notice-snack-alert__error{\n    border-color: var( --app-fill-color-primary--danger);\n    color: var(--app-text-color-primary);\n    background-color: var(--app-fill-color-notice-bg-error)!important;\n\n}\n.alert-notice-snack-alert__warning{\n    border-color: var(--app-fill-color-primary--warning);\n    color: var(--app-text-color-primary);\n    background-color: var(--app-fill-color-notice-bg-warning)!important;\n}\n.alert-notice-snack-alert__success{\n    border-color: var(--app-fill-color-success);\n    color: var(--app-text-color-primary);\n    background-color: var(--app-fill-color-notice-bg-success)!important;\n}\n.alert-notice-snack-alert__info{\n    border-color: var(--app-fill-color-success);\n    color: var(--app-text-color-primary);\n    background-color: var(--app-fill-color-notice-bg-success)!important;\n}\n.alert-notice-snack-alert__btn-close.MuiIconButton-root{\n    color: var(--app-text-color-primary);\n}\n.alert-notice-snack-alert__btn-close.MuiIconButton-sizeSmall{\n    font-size: 0.85rem;\n}\n\n.alert-notice-snack__overlay{\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    z-index: 230;\n    background-color: var(--app-menu-icon__text-color--secondary);\n}\n\n.alert-notice-line-clamp {\n    display: -webkit-box;\n    line-clamp: 4;\n    -webkit-line-clamp: 4;\n    -webkit-box-orient: vertical;\n    overflow: hidden;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
